import { render, staticRenderFns } from "./AdHocCommunity.vue?vue&type=template&id=b8888954"
import script from "./AdHocCommunity.vue?vue&type=script&lang=js"
export * from "./AdHocCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports